import styled from 'styled-components';

export const Container = styled.div`
  > div {
    display: flex;
    margin-top: 85px;

    > img {
      width: 345px;
      height: 269px;
    }

    > div {
      margin-left: 90px;
    }
  }

  > footer {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    margin-top: 50px;

    > *:last-child {
      margin-left: 20px;
    }
  }
`;

export const TextWrapper = styled.div`
  > h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #4f4f4f;
  }

  > p {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #4f4f4f;
    padding-left: 0;
  }
`;
